const initial_state = "fr";

const reducerLanguage = (state = initial_state, action) => {
    switch (action.type) {
        case "CHANGE_LANGUAGE":
            return action.payload;

        default:
            return state;
    }
};

export default reducerLanguage;



// WEBPACK FOOTER //
// ./src/reducers/reducer-language.js